import {classNames as $6e6392558d48dfec$export$ce4ab0c55987d1ff} from "../utils/classNames.mjs";
import "./styles.css";
import $kUAIr$styles_cssmjs from "./styles_css.mjs";
import {ListViewContext as $9710157b2ac3a032$export$870039b0abfe3de0} from "./ListView.mjs";
import $kUAIr$react, {useContext as $kUAIr$useContext, useRef as $kUAIr$useRef} from "react";
import {useVisuallyHidden as $kUAIr$useVisuallyHidden} from "react-aria/VisuallyHidden";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}





function $9f6a882f2314049c$export$2e2bcd8739ae039(props) {
    let { dropState: dropState, dragAndDropHooks: dragAndDropHooks } = (0, $kUAIr$useContext)((0, $9710157b2ac3a032$export$870039b0abfe3de0));
    const { target: target, isPresentationOnly: isPresentationOnly } = props;
    let ref = (0, $kUAIr$useRef)(null);
    let { dropIndicatorProps: dropIndicatorProps } = dragAndDropHooks.useDropIndicator(props, dropState, ref);
    let { visuallyHiddenProps: visuallyHiddenProps } = (0, $kUAIr$useVisuallyHidden)();
    let isDropTarget = dropState.isDropTarget(target);
    if (!isDropTarget && dropIndicatorProps['aria-hidden']) return null;
    return /*#__PURE__*/ (0, $kUAIr$react).createElement("div", {
        role: "row",
        "aria-hidden": dropIndicatorProps['aria-hidden']
    }, /*#__PURE__*/ (0, $kUAIr$react).createElement("div", {
        role: "gridcell",
        "aria-selected": "false",
        className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($kUAIr$styles_cssmjs))), 'react-spectrum-ListViewInsertionIndicator', {
            'react-spectrum-ListViewInsertionIndicator--dropTarget': isDropTarget
        })
    }, !isPresentationOnly && /*#__PURE__*/ (0, $kUAIr$react).createElement("div", {
        ...visuallyHiddenProps,
        role: "button",
        ...dropIndicatorProps,
        ref: ref
    })));
}


export {$9f6a882f2314049c$export$2e2bcd8739ae039 as default};
//# sourceMappingURL=InsertionIndicator.mjs.map
